<template>
    <div class="row" style="padding:0px; margin-top:16px;">
        <div class="col-sm-12">
            <h2 >{{ t('clients.subscription.upcoming_payment_plan') }}</h2>
            <div class="stroke col-sm-12" style=" display: flex; margin-top:16px;">
                <div class="col-sm-2">
                    <div style="display: flex">
                        <i class="fal" :class="icon" :style="{color: iconColor}"></i>
                        <span style="padding-left: 4px;">{{t(`clients.company.subscription.type.${subscription.type.type}`)}}</span>
                    </div>
                    <div v-if='subscription.payment_interval' style="display: block; font-size: 12px; margin-top: 5px;">{{t(`clients.company.subscription.payment_interval`)}}: {{t(`clients.company.subscription.payment_interval.${subscription.payment_interval}`)}}</div>
                    <div v-else style="display: block; font-size: 12px; margin-top: 5px;">{{t(`clients.company.subscription.payment_interval`)}}: {{t(`clients.company.subscription.payment_interval.free`)}}</div>
                </div>
                <div class="col-sm grey-bg" style="display:flex;">
                    <div class="icon" style="width:10%;"><i class="fal fa-clock"></i></div>
                    <div>{{ t('clients.subscription.start_date')}}: <br/> {{ subscription.subscribed_from_formatted }}</div>
                    <div style='margin-left: 20px;'>{{ t('clients.subscription.end_date')}}: <br/> {{ subscription.subscribed_till_formatted }}</div>
                </div>
                <div class="col-sm grey-bg" style="display:flex;">
                    <div class="icon" style="width:10%;"><i class="fal fa-boxes"></i></div>
                    <div>{{ t('clients.subscription.max_sync')}}: {{ subscription.type.max_sync }}</div>
                </div>

                <div @click='cancelUpcomingSubscription' v-if="subscription.payments[0].status !== 'paid'" class="col-sm-2" style="align-items: center; display: flex; cursor:pointer;">
                    <i class="fal fa-stop-circle" ></i>
                    <span style="padding-left: 4px;">{{ t('clients.subscription.cancel_payment_plan') }}</span>
                </div>

                <div v-else class="col-sm-2" style="align-items: center; display: flex; cursor:pointer;" v-tooltip.bottom="`${ t('clients.subscription.cancel_payment_plan_not_possible') }`">
                    <i class="fal fa-stop-circle" ></i>
                    <span style="padding-left: 4px;">{{ t('clients.subscription.cancel_payment_plan') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import swal from 'sweetalert';
import { get, remove } from '@/helpers/http';
import handleError from '@/helpers/error';

export default {
    name: 'UpcomingSubscriptionInformation',

    props: {
        subscription: {
            type: Object,
        },
    },

    created() {
        // this.getUpcomingSubscription();
    },

    methods: {
        cancelUpcomingSubscription() {
            this.$emit('cancelUpcomingSubscription');
        },
    },

    computed: {
        icon() {
            let icon = '';

            if (this.subscription.type.type === 'yearly') {
                icon = 'fa-gem';
            } else if (this.subscription.type.type === 'once') {
                icon = 'fa-peace';
            } else {
                icon = 'fa-heart';
            }

            return icon;
        },

        iconColor() {
            let iconColor = '';

            if (this.subscription.type.type === 'yearly') {
                iconColor = '#FECB18';
            } else if (this.subscription.type.type === 'once') {
                iconColor = '#86DEB7';
            } else {
                iconColor = '#F879C3';
            }

            return iconColor;
        },
    }
};
</script>
<style lang="scss" scoped>
.stroke {
    background-color: white;
    padding: 8px;
    border-radius: 5px;
}

.grey-bg {
    background-color: $bluegrey;
    padding: 10px;
    margin-right:8px;
    border-radius: 5px;
}
</style>
